import { TStore } from '@/common/basis/types/tstore';

const state: TStore.Person = {
  user: undefined,
};

export default state;
